import { i18n } from "next-i18next";
import { loadLocaleFromJson } from "./loadLocaleFromJson";

export async function loadLocale(locale: string, fromJSON: string, toJSON: string) {
  try {
    const JsonData = await loadLocaleFromJson(locale, fromJSON);
    i18n.addResourceBundle(locale, toJSON, JsonData.data);
  } catch {
  }
}
